import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { convertTimestampToDate } from 'helpers';
import { IconButton } from 'styles/util';

/**
 * プログラムファイルの行を表示するコンポーネント
 */
const File = (props) => {
  const { item } = props;
  const isSecondFile = (filename) => {
    return filename.lastIndexOf('_2') === filename.length - 2;
  };

  return (
    <tr>
      <td>
        {isSecondFile(item.key) ? item.key :
          <Link to={`/srv/version/detail/${item.key}`}>
            {item.key}
          </Link>
        }
      </td>
      <td>{item.size}</td>
      <td>{convertTimestampToDate(item.lastModified)}</td>
      <td>
        {!isSecondFile(item.key) && <IconButton>
          <Link to={`version/edit/${item.key}`} style={{color: 'black'}}>
            <i className="fa fa-edit" aria-hidden="true"></i>
          </Link>
        </IconButton>
        }
      </td>
    </tr>  
  );
};
File.propTypes = {
  item: PropTypes.object
};
File.defaultProps = {
  item: {
    key: '',
    size: 0,
    lastModified: ''
  }
};
export default File;
